
import React from 'react';
import { connect } from 'react-redux';
import * as ConfigTypes from 'config/ConfigTypes';
import { withRouter } from 'helpers/ModuleHelper';
import { injectIntl } from 'react-intl';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import { getMetaConfig } from "helpers/ConfigHelper";
import { getFi, showFeCartMsg } from "helpers/CartHelper";
import ListItem from "components/Cart/ListItem/ListItem";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { isHome } from 'helpers/AppHelper';
import * as actions from 'store/actions';

import './CartList.scss';

const CartList = observer(
    class CartList extends React.Component {
        constructor(props) {
            super(props);
            this.state = {}
        }

        fm = ({ id }) => this.props.intl.formatMessage({ id });

        getHeaderClasses = (configName) => {
            if (configName === ConfigTypes.ITEM) {
                return "cartlist-header-items";
            }
            return "cartlist-header";
        }

        onListItemClick = (item) => {
            const { wpView } = this.props.mediaObjects;
            this.props.updateMediaObjects({
                currentClip: item,
                wpView: ConfigTypes.ITEM_DETAIL,
                viewMode: ConfigTypes.ITEM_DETAIL,
                toTop: true,
                lastView: wpView
            });
            this.props.onCloseModal();
            this.props.router.navigate(`${ConfigTypes.ITEM_PATH}/${item.id}`);
        }


        onDateAction = async ({ item, dates }) => {
            const { itemsCartList, itemsDateObj } = this.props.cartObjects;
            let nShows = [];
            let newDates = dates.map(date => {
                let newDate = date.setTime(date.getTime() + ConfigTypes.ADD_TWO_HOURS);
                newDate = new Date(newDate).toISOString().split('T')[0];
                return newDate;
            });
            const newItems = itemsCartList.map(el => {
                if (el.id === item.id) {
                    let fi = getFi();
                    el.metadata.fields[`${fi}Price`] = ConfigTypes.DEFAULT_PRICE;
                    el.metadata.fields[`${fi}Shipping`] = ConfigTypes.DEFAULT_SHIPPING;
                    el.metadata.fields[`${fi}Start`] = newDates[0];
                    el.metadata.fields[`${fi}End`] = newDates[newDates.length - 1];
                    el.metadata.fields[`${fi}Count`] = newDates.length;
                    el.metadata.fields[`${fi}Dates`] = newDates;

                    el[`${fi}Start`] = newDates[0];
                    el[`${fi}End`] = newDates[newDates.length - 1];
                    el.showdates = newDates;
                }
                return el;
            });

            console.log("LOGS: onDateAction CartList item newDates", item, newDates);
            //this.props.addToFeCart({ clid: item.id, showdates: newDates });
            const res = await window.flow.sdkFeReAddToCart(item.id, newDates);
            console.log("LOGS: LAMTEST addToFeCart res", res);
            if (res && res.success) {
                this.props.updateCartObjects({
                    itemsCartList: newItems,
                    itemsDateObj: { ...itemsDateObj, [item.id]: newDates }
                });
            }
            showFeCartMsg({ msg: res.msg, fm: this.fm, props: this.props });

        }

        onOtherActions = ({ item, action }) => {
            const { itemsCartList } = this.props.cartObjects;
            let newItemsCart = [...itemsCartList];
            if (action && action === ConfigTypes.DELETE) {
                newItemsCart = itemsCartList.filter(li => li.id !== item.id);
                if (item.rentelid) this.props.removeFromFeCart({ rentelid: item.rentelid });
            }
            this.props.updateCartObjects({ itemsCartList: newItemsCart });
        }

        setShowsCount = ({entry, item,userInputs}) => {
              const { itemsShowsObj } = this.props.cartObjects;
             entry.shows = entry.showdates.map(date => {
                if (entry.id == item.id) {
                    if (userInputs[date]) return parseInt(userInputs[date]);
                }
                if (itemsShowsObj[entry.id] && itemsShowsObj[entry.id][date]) {
                    return parseInt(itemsShowsObj[entry.id][date]);
                }
                return 1;
            });
            return entry
        }

        onEditItem = ({ item, userInputs }) => {
            const { itemsCartList} = this.props.cartObjects;
            if (itemsCartList && itemsCartList.length) {
                let newItemsCart = itemsCartList.map(entry => {
                    return this.setShowsCount({entry, item,userInputs});
                });
                this.props.updateCartObjects({ itemsCartList: newItemsCart, itemsChanged: true });
            }
        }

        onDeleteItem = ({item, el, userInputs}) => {
            const { itemsCartList } = this.props.cartObjects;
           console.log("LOGS: onDeleteItem item el", item, el);
            if (itemsCartList && itemsCartList.length) {
                let newItemsCart = itemsCartList.map(entry => {
                    if (entry.id == item.id) {
                        let idx = entry.showdates.indexOf(el);
                        if(idx > -1){
                            entry.showdates = entry.showdates.filter(d => d == el);
                            entry.shows = entry.shows.slice(idx,1);
                        }
                    }
                    return this.setShowsCount({entry, item,userInputs});
                });
                console.log("LOGS: onDeleteItem newItemsCart", newItemsCart);
                this.props.updateCartObjects({ itemsCartList: newItemsCart, itemsChanged: true });
            }
        }

        checkEditItem = () => {
            const { itemsCartList, itemsShowsObj, itemsChanged } = this.props.cartObjects;
            if (itemsCartList && itemsCartList.length) {
                let rentels = [];
                if (itemsChanged) {
                    itemsCartList.forEach(entry => {
                        rentels.push({ id: entry.rentelid, showdates: entry.showdates, shows: entry.shows });
                    });
                } else {
                    itemsCartList.forEach(entry => {
                        let shows = [];
                        entry.showdates.forEach(date => {
                            if (itemsShowsObj[entry.id] && itemsShowsObj[entry.id][date]) {
                                let tmp = parseInt(itemsShowsObj[entry.id][date]);
                                shows.push(tmp);
                            } else shows.push(1);
                        })
                        rentels.push({ id: entry.rentelid, showdates: entry.showdates, shows: shows });
                    });
                }

                console.log("LOGS: checkEditItem rentels", rentels);
                this.props.editFeRentel({ rentels: rentels });
                this.props.updateCartObjects({ itemsChanged: false });
            }
        }


        isEmpty = () => {
            const { itemsCartList } = this.props.cartObjects;
            if (itemsCartList.length === 0) return true;
            return false;
        }

        calculateData = () => {
            const { itemsCartList } = this.props.cartObjects;
            let rentalFee = 0, shippingFee = 0, keyFee = 0, vatProcent = 0.07, processingFee = 0, cartTotal = 0;
            let vatFee = 0, subTotal = 0;
            let fi = `${ConfigTypes.ONLY_CART}screening`;
            if (itemsCartList && itemsCartList.length > 0) {
                itemsCartList.forEach(item => {
                    let price = item.metadata.fields[`${fi}Price`]
                        ? Number(item.metadata.fields[`${fi}Price`]) : ConfigTypes.DEFAULT_PRICE;
                    let count = item.metadata.fields[`${fi}Count`]
                        ? Number(item.metadata.fields[`${fi}Count`]) : ConfigTypes.DEFAULT_COUNT;
                    let shipping = item.metadata.fields[`${fi}Shipping`]
                        ? Number(item.metadata.fields[`${fi}Shipping`]) : ConfigTypes.DEFAULT_SHIPPING;
                    rentalFee += price * count;
                    shippingFee += shipping * count;
                });
                if (rentalFee) {
                    keyFee = 15;
                    subTotal = rentalFee + shippingFee + Number(keyFee);
                    vatFee = subTotal * vatProcent;
                    cartTotal = subTotal + vatFee;
                }
                this.props.updateCartObjects({
                    rentalFee: rentalFee.toFixed(2) || '0',
                    shippingFee, cartTotal: cartTotal.toFixed(2), keyFee,
                    vatFee: vatFee.toFixed(2), processingFee: processingFee.toFixed(2)
                });
                this.props.updateMediaObjects({ viewMode: ConfigTypes.CART_REQUEST });
            }
        }

        handleCartRequest = () => {
            if (this.isEmpty()) {
                this.props.updateCartObjects({ cartMessage: ConfigTypes.CART_EMPTY });
            } else {
                this.checkEditItem();
                this.calculateData();
                if (!isHome()) this.props.router.navigate("/");
                this.props.updateCartObjects({ shopForm: null });
            }
        }

        addWorks = () => {
            if (!isHome()) this.props.router.navigate("/");
            this.props.updateMediaObjects({ viewMode: ConfigTypes.LIST });
            this.props.updateCartObjects({ shopForm: null });
        }

        onFooterClick = (action) => {
            switch (action) {
                case ConfigTypes.ADD_WORKS:
                    return this.addWorks();
                case ConfigTypes.CART_REQUEST_ACTION:
                    return this.handleCartRequest();
            }
        }

        getShowFields = () => {
            let configName = ConfigTypes.ITEM;
            let showFields = getMetaConfig({
                viewMode: ConfigTypes.CARTLIST, props: this.props, configName
            });
            let addFields = getMetaConfig({
                viewMode: ConfigTypes.CARTLIST_WORKTOITEM,
                props: this.props, configName: ConfigTypes.WORK
            });
            addFields = addFields.map(el => ({ ...el, field: `${ConfigTypes.ONLY_CART}${el.field}` }));
            showFields.splice(0, 0, ...addFields);
            // showFields.unshift(ConfigTypes.CALENDAR_OBJ);
            showFields = showFields.filter(field => !field[`${ConfigTypes.CARTLIST_WORKTOITEM}hidden`]);
            let last = showFields.pop();
            showFields.push(ConfigTypes.SHOWDATES_OBJ);
            showFields.push(ConfigTypes.CALENDAR_OBJ);
            showFields.push(last);
            console.log("LOGs: LAMTEST CartList showFields", showFields);
            return showFields;
        }

        showItemsCartList = () => {
            const { itemsCartList } = this.props.cartObjects;
            // if (itemsCartList && itemsCartList.length > 0) {
            let showFields = this.getShowFields();
            return (
                <div>
                    <div className={this.getHeaderClasses(ConfigTypes.ITEM)}>
                        {showFields.map(item => (
                            <div>{item.intl && this.props.intl.formatMessage({ id: item.intl })}</div>))}
                    </div>
                    <ul className="cartlist-body">
                        {itemsCartList && itemsCartList.map((item, i) => (
                            <ListItem key={`cartlistCard_${i}`} actions={ConfigTypes.CARTLIST_ITEMS_ACTIONS}
                                item={item} isCart={true} curMode={ConfigTypes.CARTLIST} configName={ConfigTypes.ITEM}
                                onOtherActions={this.onOtherActions} showFields={showFields} onEditItem={this.onEditItem}
                                formatMessage={this.props.intl.formatMessage} cartObjects={this.props.cartObjects}
                                updateCartObjects={this.props.updateCartObjects} onDeleteItem={this.onDeleteItem}
                                onDateAction={this.onDateAction} onListItemClick={this.onListItemClick} />)
                        )}
                    </ul>
                </div>)
            //  }
        }

        showFormTitle = () => {
            return (
                <h1 className="cartlist-title">
                    <span><FontAwesomeIcon icon={faCartShopping} /></span>
                    {this.props.intl.formatMessage({ id: "cartlist.heading" })}
                </h1>
            )
        }

        showFormInfo = () => {
            return (
                <div className="cartlist cartlist-infoxbox">
                    <div>
                        {this.showFormTitle()}
                        <p className="cartlist-info">
                            {this.props.intl.formatMessage({ id: "cartlist.emptyinfo" })}
                        </p>
                    </div>
                </div>
            )
        }

        showFooter = () => {
            return ConfigTypes.CARTLIST_FOOTER.map(item => (
                <div className="cartlist-footer-item"
                    onClick={() => this.onFooterClick(item.action)}>
                    <div>{this.props.intl.formatMessage({ id: item.intl })}</div>
                    <FontAwesomeIcon icon={item.icon} />
                </div>
            ))
        }

        render() {
            //if (this.isEmpty()) return this.showFormInfo();
            return (
                <div className="cartlist">
                    {(!this.state.loading) && (
                        <div>
                            {this.showFormTitle()}
                            {this.showItemsCartList()}
                        </div>
                    )}
                    <div className="cartlist-footer">{this.showFooter()}</div>
                </div>
            )
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    configObjects: state.config.configObjects,
    cartObjects: state.cart.cartObjects,
});

const mapDispatchToProps = (dispatch) => ({
    updateAuthObjects: (obj) => dispatch(actions.updateAuthObjects(obj)),
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    removeFromFeCart: (obj) => dispatch(actions.removeFromFeCart(obj)),
    editFeRentel: (obj) => dispatch(actions.editFeRentel(obj)),
    addToFeCart: (obj) => dispatch(actions.addToFeCart(obj)),
    getCart: () => dispatch(actions.getCart()),
})

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(CartList))));